import { render, staticRenderFns } from "./DeclaracoesEstaduais.vue?vue&type=template&id=1af31f17&"
import script from "./DeclaracoesEstaduais.vue?vue&type=script&lang=js&"
export * from "./DeclaracoesEstaduais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports